import { useEffect, useState, useRef, useMemo, use } from 'react';
import Header from '../components/header';
import './relatorio.css'
import { useLocation } from 'react-router-dom';
import Icon from '@mdi/react';
import Gratuito from './grauito';
import { GoogleMap, Marker, StreetViewPanorama } from "@react-google-maps/api";
import LoadingRelatorio from '../components/loading_relatorio';
import Indicadores from './indicadores';
import RelatorioPago from './relatorio_pago';
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { mdiMapMarkerRadius } from '@mdi/js';
import Footer from '../components/footer';
import { API_BASE_URL } from '../../global';
import { registrarLog } from "../../global";
import Popup from '../components/popup';

const GOOGLE_API = 'AIzaSyCRJnBSTStmvD5-WUr03HCQNHJ44N4Nz5g';

export default function Relatorio({ isAuth, setIsAuth }) {

  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [resultado, setResultado] = useState(location.state?.resultado)

  const [loadBar, setLoadBar] = useState(0);

  const [popup, setPopup] = useState(false);
  const [popupTitulo, setPopupTitulo] = useState('');
  const [popupMensagem, setPopupMensagem] = useState('');
  const [popupOpcoes, setPopupOpcoes] = useState('ok');
  const [popupIcone, setPopupIcone] = useState('erro');

  //VERIFICAÇÃO DE AUTENTICAÇÃO
  useEffect(() => {
    const verified = localStorage.getItem("verificado");
    const auth = localStorage.getItem("auth");
    if (verified === "false") {
      navigate('/EmailVerify')
    }
  }, []);

  //CAPTURA O CENTRO DE LATITUDE E LONGITUDE - POSIÇÃO DO STREET VIEW
  const center = resultado
    ? {
      lat: resultado.geometry.location.lat,
      lng: resultado.geometry.location.lng
    }
    : null;



  const endereco = useMemo(() => {
    if (!resultado) return


    const components = resultado.address_components;
    console.log(components)
    return {
      rua: getComponent(components, "route"),
      bairro:
        getComponent(components, "sublocality") ||
        getComponent(components, "political"),
      cidade: getComponent(components, "administrative_area_level_2"),
      estado: getComponent(components, "administrative_area_level_1"),
      latitude: resultado.geometry.location.lat,
      longitude: resultado.geometry.location.lng,
      numero: getComponent(components, "street_number")
    };
  }, [resultado]);

  const [gratuito, setGratuito] = useState(true);

  const [loading, setLoading] = useState(true)
  const mapRef = useRef(null);
  const streetRef = useRef(null);
  const streetInitialized = useRef(false);
  const [mapReady, setMapReady] = useState(false);

  const [cep, setCep] = useState(searchParams.get("cep"));

  const [ruaDB, setRuaDB] = useState('');
  const [numeroDB, setNumeroDB] = useState('');
  const [bairroDB, setBairroDB] = useState('');
  const [cidadeDB, setCidadeDB] = useState('');

  const [dataRelatorio, setDataRelatorio] = useState({
    pontos_onibus: { total: 0, pontos: [] },
    estacoes_metro: { total: 0, estacoes: [] },
    terminais_onibus: { total: 0, terminais: [] },
    estacoes_trem: { total: 0, estacoes: [] },
    ocorrencias_geo_hidro: { alagamentos: { total: 0, ocorrencias: [] }, inundacoes: { ocorrencias: [], total: 0 }, deslizamentos: { ocorrencias: [], total: 0 }, queda_arvore: { ocorrencias: [], total: 0 } },
    seguranca_publica: { ocorrencias_default: { ocorrencias: [], ocorrencias_total: 0 }, ocorrencias_12_meses: { ocorrencias: [], ocorrencias_total: 0 }, media_12_meses: 0, tipo_ocorrencias: { ocorrencias: [], ocorrencias_distintas: 0 }, bairro: { ocorrencias: [], ocorrencias_total: 0, ocorrencias_12_meses: { ocorrencias: [], ocorrencias_total: 0 }, media_12_meses: 0, tipo_ocorrencias: { ocorrencias: [], ocorrencias_distintas: 0 } } },
    restaurantes: [],
    supermercados: [],
    farmacias: [],
    hospitais: [],
    climaTempo: []
  });

  const [dadosIndicadores, setDadosIndicadores] = useState({
    pontos_onibus: 0,
    terminais_onibus: 0,
    estacoes_metro: 0,
    seguranca_publica: 0,
    restaurantes: 0,
    supermercados: 0,
    farmacias: 0,
    hospitais: 0,
    climaTempo: 0
  })

  //DADOS INDICADORES
  const baseIndicadores = async () => {
    setLoading(true)
    try {
      const response = await fetch(`${API_BASE_URL}/relatorio/calculo-indicadores.php`, {
        method: 'POST',
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          rua: endereco.rua,
          bairro: endereco.bairro,
          cep: cep,
          estado: endereco.estado,
          cidade: endereco.cidade,
          lat: endereco.latitude,
          lng: endereco.longitude
        })
      })

      const data = await response.json();
      if (data) {
        setDadosIndicadores(data)
        setLoadBar(60)
      } else {
        setLoading(false)
        console.log("Erro durante coleta de dados de indicadores")
      }

    } catch (error) {
      setLoading(false)
      console.log(error);
    }
  }

  //PUXAR DADOS DO RELATÓRIO PREMIUM
  const relatorioPremium = async () => {
    if (!endereco) {
      setLoading(false);
      return;
    }

    setLoading(true);
    await baseIndicadores();
    try {
      const response = await fetch(`${API_BASE_URL}/relatorio/get_dados_relatorio.php`, {
        method: 'POST',
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          rua: endereco.rua,
          bairro: endereco.bairro,
          cep: cep,
          estado: endereco.estado,
          cidade: endereco.cidade,
          lat: endereco.latitude,
          lng: endereco.longitude
        })
      })

      const data = await response.json();
      setDataRelatorio(data);
      setLoading(false);
      setLoadBar(100);

      registrarLog('Relatório', 'Visualizou relatório Premium', cep);
    } catch (error) {
      setLoading(false)
      console.error(error)
    }
  }


  //1º - VERIFICA SE O RELATÓRIO FOI ADQUIRIDO
  const verificarAquisicaoRelatorio = async () => {
    setLoading(true)
    try {
      const response = await fetch(`${API_BASE_URL}/relatorio/verificar_aquisicao.php`, {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          cep: cep,
        })
      })

      const data = await response.json();
      if (data.status === 'success') {

        if (data.msg === 'Relatório adquirido') {
          setRuaDB(data.data.rua);
          setNumeroDB(data.data.numero);
          setBairroDB(data.data.bairro);
          setCidadeDB(data.data.cidade);
          setGratuito(false);
          if (resultado) {
            await relatorioPremium();
            setLoading(false);
            setLoadBar(40)
          }

        } else {
          await baseIndicadores();
          setGratuito(true);
          registrarLog('Relatório', 'Visualizou relatório gratuito', cep);
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }

  useEffect(() => {
    if (cep) {
      verificarAquisicaoRelatorio();
    }
  }, [cep]);


  function getComponent(components, type) {
    const item = components.find(c => c.types.includes(type));
    return item?.long_name || null;
  }


  useEffect(() => {
    if (resultado) {
      const components = resultado.address_components;
      const cepResultado = getComponent(components, "postal_code");
      if (cepResultado && cepResultado !== cep) {
        setCep(cepResultado);
      }
    }
  }, [resultado]);


  //MAPA DO STREET VIEW
  useEffect(() => {
    if (!center || !mapReady || !streetRef.current || streetInitialized.current) return;

    streetInitialized.current = true;

    const panorama = new window.google.maps.StreetViewPanorama(
      streetRef.current,
      {
        position: center,
        pov: { heading: 100, pitch: 0 },
        zoom: 1
      }
    );

    mapRef.current.setStreetView(panorama);

  }, [mapReady, center]);


  //CALLBACK PARA CHAMAR RELATÓRIO PREMIUM
  useEffect(() => {
    if (!gratuito && resultado) {
      relatorioPremium();
    }
  }, [gratuito, resultado]);

  useEffect(() => {
    if (!resultado && cep) {
      const fetchResultadoCep = async () => {
        try {
          const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(cep)}&components=country:BR&key=${GOOGLE_API}`;
          const response = await fetch(url);
          const data = await response.json();
          if (data.status === "OK") {
            setResultado(data.results[0]);
          } else {
            setLoading(false);
            navigate('/');
          }
        } catch (error) {
          console.error("Erro ao buscar CEP alternativo:", error);
          setLoading(false);
          navigate('/');
        }
      }
      fetchResultadoCep();
    } else if (!resultado && !cep) {
      navigate('/');
    }
  }, [cep, resultado, navigate]);



  if (!resultado) {
    return <LoadingRelatorio />;
  }


  const components = resultado.address_components;

  const rua = getComponent(components, "route");
  const bairro = getComponent(components, "sublocality")
    || getComponent(components, "political");
  const cidade = getComponent(components, "administrative_area_level_2");
  const estado = getComponent(components, "administrative_area_level_1");
  const numero = getComponent(components, "street_number")
  const latitude = resultado.geometry.location.lat
  const longitude = resultado.geometry.location.lng
  const zoom = 18;


  const desbloquearRelatorio = async () => {
    registrarLog('Relatório', 'Clicou em desbloquear relatório', null);
    if (!isAuth) return navigate('/Autenticacao')

    try {
      const response = await fetch(`${API_BASE_URL}/relatorio/desbloquear-relatorio.php`, {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          cep: cep,
          rua: rua,
          numero: numero,
          latitude: latitude,
          longitude: longitude,
          bairro: bairro,
          cidade: cidade
        })
      })
      const data = await response.json();
      if (data.status === 'success') {
        if (data.msg === 'Relatório adquirido com sucesso') {
          registrarLog('Relatório', 'Adquiriu relatório', null);
          navigate(0);
          setGratuito(false);

        } else {
          setPopup(true);
          setPopupTitulo('Falha na aquisição');
          setPopupIcone('cancel');
          setPopupMensagem('Ocorreu um erro ao desbloquear o relatório. Entre em contato com o suporte.');
          setGratuito(true);
          setLoading(false);
        }
      } else {
        console.log(data.status)
        setPopup(true);
        setPopupTitulo('Créditos insuficientes');
        setPopupIcone('cancel');
        setPopupMensagem('Você não possui créditos suficientes para desbloquear este relatório.');
        setGratuito(true);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }


  function handleMapLoad(map) {
    mapRef.current = map;
    setMapReady(true);
  }







  return (
    <div className="relatorio_body">

      {loading && (<LoadingRelatorio loadBar={loadBar} setLoadBar={setLoadBar}></LoadingRelatorio>)}

      <Header isAuth={isAuth} setIsAuth={setIsAuth} />

      <div className='relatorio_container' id='relatorio_completo' >
        <div className='relatorio_titulo'>
          <h1>Relatório de Ocorrências e Riscos</h1>
          <h2>{rua}</h2>
          <p>{bairro}, {cidade}, {estado}</p>
          <p>{cep}</p>
        </div>


        <div className="map-wrapper">

          <GoogleMap
            onLoad={handleMapLoad}
            mapContainerStyle={{ width: "100%", height: "100%" }}
            center={center}
            zoom={zoom}
            options={{
              draggable: false,
              zoomControl: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              gestureHandling: "none",
              streetViewControl: false,
            }}
          />

          <div
            ref={streetRef}
            className='street-view'

          />

        </div>
        <p className='micro-legenda' style={{ marginTop: 0, marginBottom: 20, width: '100%', backgroundColor: '#FF6F3311', borderColor: '#FF6F3355', color: '#666' }}><Icon path={mdiMapMarkerRadius} size={1} style={{ verticalAlign: '-3px' }} /> Visualização geográfica do endereço analisado e seu entorno imediato, com base em dados oficiais de localização.</p>

        <Indicadores dadosIndicadores={dadosIndicadores} cidade={cidade}></Indicadores>

        {gratuito && <Gratuito desbloquearRelatorio={desbloquearRelatorio} dadosIndicadores={dadosIndicadores}></Gratuito>}

        {!gratuito && <RelatorioPago dataRelatorio={dataRelatorio} googleAPI={GOOGLE_API} rua={rua} latitude={latitude} longitude={longitude} cidade={cidade}></RelatorioPago>}

      </div>

      <Popup titulo={popupTitulo} mensagem={popupMensagem} opcoes={popupOpcoes} icone={popupIcone} setPopup={setPopup} popup={popup}></Popup>
      <Footer></Footer>
    </div>
  );
}
